export const ACTIONS = Object.freeze({
  FILE_WRITE: 'file.write',
  FILE_CREATE: 'file.create',
  FILE_DELETE: 'file.delete',
  FILE_DOWNLOAD: 'file.download',
  FILE_SHARE: 'file.share',
  FOLDER_MANAGE: 'folder.manage',
  FOLDER_CREATE: 'folder.create',
  SHARE_CREATE: 'share.create',
  SHARE_REVOKE: 'share.revoke',
  FILE_REQUEST_CREATE: 'file_request.create',
  FILE_REQUEST_MANAGE: 'file_request.manage',
  COMMENT_WRITE: 'comment.write',
  COMMENT_RESOLVE: 'comment.resolve',
  CHAT_READ: 'chat.read',
  CHAT_POST: 'chat.post',
  CHAT_MODERATE: 'chat.moderate',
  SECRET_READ: 'secret.read',
  SECRET_CREATE: 'secret.create',
  SECRET_DELETE: 'secret.delete',
  MEMBER_INVITE: 'member.invite',
  MEMBER_MANAGE: 'member.manage',
  WORKSPACE_MANAGE: 'workspace.manage',
  SIGNATURE_SEND: 'signature.send',
  FORM_MANAGE: 'form.manage',
});
